import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TabBar, TabButton } from '~/components';
import { theme } from '~/styles/theme';
import * as S from './styles';
import KitTeam from '../KitTeam';

export default function TeamSection({
  type,
  selectedMatch,
  kitSelected,
  tabMode,
  kits,
}) {
  const { t } = useTranslation();
  const [tab, setTab] = useState('goalkeeper');

  const changeTab = ({ value }) => {
    setTab(value);
  };

  const styleTab = {
    primaryColor: type !== 'away' ? theme.lightWithOpacity : theme.dark4Opacity,
    secondaryColor: type !== 'away' ? theme.dark : theme.white,
    contrastColor: type !== 'away' ? theme.dark : theme.white,
    textColor: type !== 'away' ? theme.dark : theme.white,
    isSelected: kitSelected === 1,
    withBorder: true,
  };

  return (
    <S.ContainerTeamContent tabMode={tabMode}>
      {tabMode && (
        <TabBar value={tab} onChange={changeTab} styleTab={styleTab}>
          <TabButton value="goalkeeper" label={t('goalkeeper')} />
          <TabButton value="player" label={t('player')} />
        </TabBar>
      )}
      {kitSelected === 1 && (
        <S.TeamBlockContent tabMode={tabMode}>
          {((tabMode && tab === 'goalkeeper') || !tabMode) && (
            <KitTeam
              type={type}
              position="goalkeeper"
              label={t('goalkeeper')}
              bgImage={null}
              // La imagen de error debe venir directamente del backend REVISAR
              shield={null}
              selectedMatch={selectedMatch}
              kits={kits}
            />
          )}
          {((tabMode && tab === 'player') || !tabMode) && (
            <KitTeam
              type={type}
              position="player"
              label={t('player')}
              bgImage={null}
              // La imagen de error debe venir directamente del backend REVISAR
              shield={null}
              selectedMatch={selectedMatch}
              kits={kits}
            />
          )}
        </S.TeamBlockContent>
      )}
      {kitSelected === 2 && (
        <S.TeamBlockContent tabMode={tabMode}>
          {((tabMode && tab === 'goalkeeper') || !tabMode) && (
            <KitTeam
              type={type}
              position="goalkeeper"
              label={t('goalkeeper')}
              bgImage={null}
              // La imagen de error debe venir directamente del backend REVISAR
              shield={null}
              selectedMatch={selectedMatch}
              kits={kits}
            />
          )}
          {((tabMode && tab === 'player') || !tabMode) && (
            <KitTeam
              type={type}
              position="player"
              label={t('player')}
              bgImage={null}
              // La imagen de error debe venir directamente del backend REVISAR
              shield={null}
              selectedMatch={selectedMatch}
              kits={kits}
            />
          )}
        </S.TeamBlockContent>
      )}
    </S.ContainerTeamContent>
  );
}

TeamSection.propTypes = {
  kitSelected: PropTypes.number,
  selectedMatch: PropTypes.object,
  kits: PropTypes.object,
  tabMode: PropTypes.bool,
  type: PropTypes.string,
};

TeamSection.defaultProps = {
  kitSelected: 0,
  selectedMatch: {},
  kits: {},
  tabMode: false,
  type: '',
};
